export const Types = {
    STUDY_LIST: "STUDY_LIST",
    STUDY_NOT_FOUND:"STUDY_NOT_FOUND",
    GET_DEFAULT_STUDY:"GET_DEFAULT_STUDY"
  };